<button mat-icon-button [matMenuTriggerFor]="notificationMenu" aria-label="Notifications" class="relative">
  <mat-icon svgIcon="bell"></mat-icon>
  @if (unreadCount() > 0) {
    <span
      class="absolute top-[-2px] right-[-2px] min-w-[16px] h-4 px-1 flex items-center justify-center rounded-full bg-red-9 text-[8px] font-bold text-white leading-none border border-white shadow-sm z-10"
    >
      {{ unreadCount() > 99 ? '99+' : unreadCount() }}
    </span>
  }
</button>

<mat-menu #notificationMenu="matMenu" panelClass="notifications-dropdown-panel !overflow-x-hidden">
  <!-- Header -->
  <div class="flex items-center justify-between border-b px-4 py-2 surface-default w-[360px]">
    <span class="font-semibold text-sm">Notifications</span>
    @if (unreadCount() > 0) {
      <button
        mat-button
        class="text-xs link text-primary"
        (click)="$event.stopPropagation(); markAllAsRead.emit()"
      >
        Tout marquer comme lu
      </button>
    }
  </div>

  <!-- Scrollable List -->
  <div class="max-h-80 w-[360px] overflow-y-auto py-1">
    @if (unreadNotifications().length === 0) {
      <div class="flex flex-col items-center justify-center p-6 text-muted text-xs gap-y-2">
        <mat-icon svgIcon="bell-off" class="text-neutral-8 size-8"></mat-icon>
        <span>Aucune notification</span>
      </div>
    } @else {
      @for (n of unreadNotifications(); track n._id) {
        <div
          class="flex items-start gap-x-3 px-4 py-3 hover:bg-neutral-a2 cursor-pointer transition-colors"
          [class.bg-neutral-a1]="!n.read"
          role="button"
          tabindex="0"
          (click)="onNotificationClick(n)"
          (keydown.enter)="onNotificationClick(n)"
        >
          <!-- Type Icon -->
          <div
            class="mt-0.5 flex size-7 shrink-0 items-center justify-center rounded-full"
            [class]="getIconBgClass(n.type)"
          >
            <mat-icon [svgIcon]="getIconName(n.type)" class="size-4"></mat-icon>
          </div>

          <!-- Content -->
          <div class="flex flex-1 flex-col gap-y-0.5 min-w-0">
            <span class="text-xs font-semibold text-default break-words" [class.font-bold]="!n.read">{{
              n.title
            }}</span>
            <span class="text-xs text-muted leading-snug break-words">{{ n.message }}</span>
            <span class="text-[10px] text-muted-more mt-0.5">{{ n.formattedTime }}</span>
          </div>

          <!-- Unread Dot -->
          @if (!n.read) {
            <div class="flex items-center self-center shrink-0">
              <span class="size-2 rounded-full bg-primary"></span>
            </div>
          }
        </div>
      }
    }
  </div>

  <!-- Footer -->
  <div class="border-t px-4 py-2 flex justify-center surface-default w-[360px]">
    <button mat-button class="text-xs w-full text-center link" (click)="viewAll.emit()">Tout voir</button>
  </div>
</mat-menu>
